export const ls_authToken = "authToken";
export const ls_defaultLocation = "defaultLocation";
export const ls_guestId = "guestId";
